import memoizeOne from 'react-utils/memoizeOne';
export const getOnboardingTourIdQueryParam = memoizeOne(() => {
  const urlParams = new URLSearchParams(window.location.search);
  return {
    navTourId: urlParams.get('navTourId') || ''
  };
});